import { render } from "./Index.vue?vue&type=template&id=65381c49"
const script = {}

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__